import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const VariantSlideWrap = styled.div`
  &.bottom-padding {
    padding-bottom: 96px;
    @media (max-width: 991.98px) {
      padding-bottom: 56px;
    }
    @media (max-width: 767.98px) {
      padding-bottom: 40px;
    }
  }
  &.top-padding {
    padding-top: 96px;
    @media (max-width: 991.98px) {
      padding-top: 56px;
    }
    @media (max-width: 767.98px) {
      padding-top: 40px;
    }
  }
  position: relative;
  &.floatabove {
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      background-color: ${color.common.white};
      width: 100%;
      min-height: 60%;
    }
    .heading {
      color: ${color.oxfordBlue[900]} !important;
    }
  }
  .container {
    max-width: 1170px !important;
    @media (max-width: 991.98px) {
      max-width: 770px !important;
    }
    @media (max-width: 767.98px) {
      max-width: 506px !important;
    }
  }
  .heading-container {
    text-align: center;
    max-width: 770px !important;
    margin: 0 auto;
    .eyebrow {
      font-size: 14px;
      font-weight: 500;
      border: 2px solid ${color.secondary[600]};
      border-radius: 40px;
      padding: 7px 15px 3px;
      display: inline;
      line-height: 1em;
      display: inline-block;
      margin-bottom: 24px;
      color: ${color.secondary[600]};
      @media (max-width: 575.98px) {
        font-size: 12px;
        line-height: 18px;
      }
    }
    .heading {
      text-align: center;
      letter-spacing: -0.02em;
      font-style: normal;
      font-weight: 900;
      color: ${color.oxfordBlue[900]};
      left: calc(50% - 770px / 2);
      top: 0%;
      bottom: 63.86%;
      &.heading-1 {
        font-size: 48px;
        line-height: 60px;
        @media (max-width: 991.98px) {
          font-size: 36px;
          line-height: 44px;
        }
        @media (max-width: 575.98px) {
          font-size: 24px;
          line-height: 32px;
        }
      }
      &.heading-2 {
        font-size: 36px;
        line-height: 44px;
        @media (max-width: 991.98px) {
          font-size: 30px;
          line-height: 38px;
        }
        @media (max-width: 575.98px) {
          font-size: 24px;
          line-height: 32px;
        }
      }
    }
    .description {
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      font-weight: 400;
      max-width: 770px;
      flex: none;
      align-self: stretch;
      flex-grow: 0;
      top: 45.78%;
      bottom: 0%;
      margin: 0 auto;
      * {
        color: ${color.copy[700]};
      }
    }
  }
  .main-container {
    .tabs-area {
      display: flex;
      flex-direction: row;
      justify-content: center;
      box-shadow: inset 0px 0px 0 ${color.copy[200]},
        inset -0px -2px 0 ${color.copy[200]};
      background: ${color.common.white};
      margin-bottom: 25px;
      flex-wrap: wrap;
      button {
        flex-wrap: wrap;
        padding: 18px 12px 10px;
        text-transform: none;
        color: ${color.copy[400]};
        font-size: 1.1em;
        font-family: Avenir, sans-serif;
        font-style: normal;
        font-weight: 800;
        line-height: 30px;
        min-width: fit-content;
        border-top: none;
        border-right: none;
        border-left: none;
        border-bottom: 2px solid ${color.common.transparent};
        background: ${color.common.transparent};
      }
      .active-button {
        color: ${color.primary[900]};
        border-bottom: 2px solid ${color.primary[900]};
      }
    }
    .inactive {
      display: none;
    }
    .active-slide {
      display: block;
      background: ${color.aliceBlue[50]};
      border: 10px;
      border-radius: 24px;
    }
    .tabpanel-area {
      background: ${color.aliceBlue[50]};
      border: 10px;
      border-radius: 24px;
    }
    .slide-desc {
      justify-content: space-between;
      .slide-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 24px 0 24px 56px;
        @media (max-width: 991.98px) {
          max-width: 100%;
          padding: 56px 70px 0 70px;
        }
        @media (max-width: 767.98px) {
          padding: 24px 48px 0;
        }
        a {
          color: ${color.primary[700]} !important;
          font-weight: 600;
          position: relative;
        }
        .slide-eyebrow {
          font-family: "Avenir";
          font-style: normal;
          font-weight: 900;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: ${color.primary[700]};
          margin-bottom: 16px;
          max-width: 470px;
          @media (max-width: 991.98px) {
            max-width: 100%;
          }
          @media (max-width: 575.98px) {
            font-size: 12px;
            line-height: 18px;
          }
        }
        .slide-heading {
          font-family: "Avenir";
          font-style: normal;
          font-weight: 900;
          font-size: 36px;
          line-height: 44px;
          letter-spacing: -0.02em;
          color: ${color.oxfordBlue[900]};
          margin-bottom: 16px;
          max-width: 470px;
          @media (max-width: 991.98px) {
            max-width: 100%;
            font-size: 30px;
            line-height: 38px;
          }
        }
        .slide-subhead {
          font-family: "Avenir";
          font-style: normal;
          font-weight: 350;
          font-size: 18px;
          line-height: 28px;
          color: ${color.copy[700]};
          max-width: 470px;
          @media (max-width: 991.98px) {
            max-width: 100%;
          }
        }
      }
    }
    .slideImg {
      object-fit: contain;
      max-width: 470px;
      max-height: 650px;
      height: 100%;
      width: 100%;
    }
    .slide-video {
      position: relative;
      text-align: center;
      img {
        max-width: 100%;
      }
      .playicon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        span {
          display: inline-block;
          background-color: ${color.primary[350]};
          cursor: pointer;
          border-radius: 50%;
          animation: pulse 2.5s infinite;
          width: 72px;
          height: 72px;
          line-height: 72px;
          padding-left: 6px;
          img {
            width: 26px;
            height: 30px;
          }
        }
      }
    }
  }
  &.bg-light {
    .tabs-area {
      background-color: ${color.aliceBlue[50]};
    }
  }
  &.bg-plum {
    .tabs-area {
      background-color: ${color.oxfordBlue[900]};
    }
  }
`
